import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Attachment } from '../models/attachment.dto';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private baseUrl = environment.beServiceUrl + '/v1/attachment';

  constructor(private http: HttpClient) {}

  findAttachments(id: string): Observable<Attachment[]> {
    const filter = {
      transitionId: id,
      enabled: true,
      formId: null,
    };

    return this.http.post<Attachment[]>(`${this.baseUrl}/find`, filter).pipe(
      // Gestione temporanea in attesa dell'introduzione del repository
      map((attachments: Attachment[]) => {
        const firstSignedPerType = new Map<string, number>();
        for (const att of attachments) {
          const typeCode = att.type?.code;
          if (att.signed && typeCode && !firstSignedPerType.has(typeCode)) {
            firstSignedPerType.set(typeCode, att.id);
          }
        }

        const enriched = attachments.map((att) => ({
          ...att,
          isFirstSignedOfType:
            att.signed && att.id === firstSignedPerType.get(att.type?.code),
        }));
        return enriched;
      })
    );
  }

  downloadAttachment(url: string): Observable<Blob> {
    //return this.http.get(`${this.baseUrl}/${id}/get`, { responseType: 'blob' });
    return this.http.get(url, { responseType: 'blob' });
  }

  deleteAttachment(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}/delete`);
  }

  insertAttachment() {
    const url = this.baseUrl + `/insert`;
    return this.http.post(url, null);
  }

  getLastSignedAttachment(compositionId: string) {
    return this.http.get<Attachment>(
      `${this.baseUrl}/last?compositionId=${compositionId}`
    );
  }

  insertAttachmentFromForm(request: any) {
    const url = this.baseUrl + `/sync`;
    return this.http.post(url, request);
  }
}
